import { configureStore } from '@reduxjs/toolkit';
import { userLoadingReducer } from './slices/userLoadingSlice';
import { userReducer } from './slices/userSlice';

const store = configureStore({
    reducer: {
        user: userReducer,
        userLoading: userLoadingReducer,
    },
});

export default store;
